import { useContext } from "react";
import { ThemeContext } from "styled-components";
import styled from "styled-components";
import css from "@styled-system/css";

import Typography from "../Typography/Typography";
import useThemeColor from "../useThemeColor.hook";

import { StepProps, StepWrapperProps } from "./timeline.type";

const StepWrapper = styled.div<StepWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  padding: 2px;
  border-radius: 50%;
  background-size: 100% 200%;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3) 50%,
    ${(props) => props.borderColor} 50%
  );
  ${css({
    transform: ["rotate(270deg)", "rotate(270deg)", "rotate(0deg)"],
    "& div:first-of-type": {
      transform: ["rotate(90deg)", "rotate(90deg)", "rotate(0deg)"],
    },
  })}
  -webkit-transition: background-position 0.075s;
  -moz-transition: background-position 0.075s;
  transition: background-position 0.075s;
  &.active {
    background-position: 0 -100%;
  }
`;

const Step = ({
  stepNo,
  isActive,
  onStepClick,
  backgroundColor = "secondary-nav-blue",
}: StepProps) => {
  const themeContext = useContext(ThemeContext);
  const hexBackgroundColor = useThemeColor(backgroundColor);
  const hexBorderColor = useThemeColor("secondary-orange");
  const customStyles = `
    background-color: ${hexBackgroundColor};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: ${themeContext.fontWeights.bold};
    cursor: pointer;
    `;

  return (
    <StepWrapper
      className={isActive ? "active" : ""}
      onClick={onStepClick}
      borderColor={hexBorderColor}
    >
      <Typography
        color="white"
        mx={0}
        my={0}
        textAlign="center"
        htmlTag="div"
        css={customStyles}
      >
        {stepNo}
      </Typography>
    </StepWrapper>
  );
};

export default Step;
